import { ChatApiResponse } from "../../Models/Chat";
import {
  ADD_CONVERSATION_FAILURE,
  ADD_CONVERSATION_REQUEST,
  ADD_CONVERSATION_SUCCESS,
  FETCH_CONVERSATION_BY_ID_FAILURE,
  FETCH_CONVERSATION_BY_ID_REQUEST,
  FETCH_CONVERSATION_BY_ID_SUCCESS,
  HIDE_CONVERSATION_PANE,
  IS_CONVERSATION_UPDATED,
  REGENERATE_CHAT_FAILURE,
  REGENERATE_CHAT_REQUEST,
  REGENERATE_CHAT_SUCCESS,
  SET_DEFAULT_CONVERSATION,
  SHOW_CONVERSATION_PANE,
  UPDATE_CHAT_FAILURE,
  UPDATE_CHAT_REQUEST,
  UPDATE_CHAT_SUCCESS,
  UPDATE_FEEDBACK_FAILURE,
  UPDATE_FEEDBACK_REQUEST,
  UPDATE_FEEDBACK_SUCCESS,
  UPDATE_STAR_FAILURE,
  UPDATE_STAR_REQUEST,
  UPDATE_STAR_SUCCESS,
} from "./ChatConversationType";

interface ConversationAppState {
  loading: boolean;
  regenerateLoading: boolean;
  fetchConversationLoading: boolean;
  showConversationPane: boolean;
  conversationDetails: ChatApiResponse;
  conversationLastUpdatedDateTime: string;
  isConversationUpdated: boolean;
  error: string;
}

const defaultConversationDetails = {
  id: "",
  conversationFilePath: "",
  participants: [],
  title: "",
  searchIndexId: "",
  skillId: "",
  skillCode: "",
  isArchived: false,
  createdDateTime: "",
  createdParticipantId: "",
  updatedDateTime: "",
  updatedParticipantId: "",
  chats: [],
};

export const initialState: ConversationAppState = {
  loading: false,
  regenerateLoading: false,
  fetchConversationLoading: false,
  showConversationPane: false,
  conversationLastUpdatedDateTime: new Date().toISOString(),
  isConversationUpdated: false,
  conversationDetails: defaultConversationDetails,
  error: "",
};

const ChatConversationReducer = (state = initialState, action: any): ConversationAppState => {
  switch (action.type) {
    case FETCH_CONVERSATION_BY_ID_REQUEST:
      return { ...state, fetchConversationLoading: true, isConversationUpdated: false };
    case FETCH_CONVERSATION_BY_ID_SUCCESS:
      return {
        ...state,
        fetchConversationLoading: false,
        conversationDetails: action.payload,
        conversationLastUpdatedDateTime: action.payload.updatedDateTime,
        showConversationPane: action.payload.chats.length > 0,
        error: "",
      };
    case FETCH_CONVERSATION_BY_ID_FAILURE:
      return { ...state, fetchConversationLoading: false, error: action.payload };
    case ADD_CONVERSATION_REQUEST:
      return { ...state, loading: true };
    case ADD_CONVERSATION_SUCCESS:
      return { ...state, loading: false, conversationDetails: action.payload, error: "" };
    case ADD_CONVERSATION_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_CHAT_REQUEST:
      return { ...state, loading: true };
    case UPDATE_CHAT_SUCCESS:
      return {
        ...state,
        loading: false,
        conversationDetails: { ...state.conversationDetails, chats: [...state.conversationDetails.chats, action.payload] },
        error: "",
      };
    case UPDATE_CHAT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_STAR_REQUEST:
      return { ...state, loading: true };
    case UPDATE_STAR_SUCCESS:
      return {
        ...state,
        conversationDetails: {
          ...state.conversationDetails,
          chats: state.conversationDetails.chats.map((chat: any) =>
            chat.id === action.payload.QuestionId
              ? {
                  ...chat,
                  star: {
                    ...chat.Star,
                    isStared: action.payload.IsStared,
                  },
                }
              : chat
          ),
        },
      };
    case UPDATE_STAR_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_FEEDBACK_REQUEST:
      return { ...state, loading: true };
    case UPDATE_FEEDBACK_SUCCESS:
      return {
        ...state,
        loading: false,
        conversationDetails: {
          ...state.conversationDetails,
          chats: state.conversationDetails.chats.map((chat: any) =>
            chat.id === action.payload.QuestionId
              ? {
                  ...chat,
                  responses: chat.responses.map((res: any) =>
                    res.id === action.payload.ResponseId
                      ? {
                          ...res,
                          thumbsUp:
                            action.payload.Option === "THUMBSUP"
                              ? res.thumbsUp.some((t: any) => t.participantId === action.payload.ParticipantId)
                                ? res.thumbsUp.filter((f: any) => f.participantId !== action.payload.ParticipantId)
                                : [
                                    ...res.thumbsUp,
                                    {
                                      participantId: action.payload.ParticipantId,
                                      createdDateTime: new Date().toISOString(),
                                      tags: action.payload.Tags,
                                      feedback: action.payload.Feedback,
                                    },
                                  ]
                              : res.thumbsUp.filter((f: any) => f.participantId !== action.payload.ParticipantId),
                          thumbsDown:
                            action.payload.Option === "THUMBSDOWN"
                              ? res.thumbsDown.some((t: any) => t.participantId === action.payload.ParticipantId)
                                ? res.thumbsDown.filter((f: any) => f.participantId !== action.payload.ParticipantId)
                                : [
                                    ...res.thumbsDown,
                                    {
                                      participantId: action.payload.ParticipantId,
                                      createdDateTime: new Date().toISOString(),
                                      tags: action.payload.Tags,
                                      feedback: action.payload.Feedback,
                                    },
                                  ]
                              : res.thumbsDown.filter((f: any) => f.participantId !== action.payload.ParticipantId),
                        }
                      : res
                  ),
                }
              : chat
          ),
        },
      };
    case UPDATE_FEEDBACK_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case REGENERATE_CHAT_REQUEST:
      return {
        ...state,
        regenerateLoading: true,

        conversationDetails: {
          ...state.conversationDetails,
          chats: state.conversationDetails.chats.map((chat: any) =>
            chat.id === action.payload.id
              ? {
                  ...chat,
                  responses: null,
                }
              : chat
          ),
        },
      };
    case REGENERATE_CHAT_SUCCESS:
      return {
        ...state,
        regenerateLoading: false,
        conversationDetails: {
          ...state.conversationDetails,
          chats: state.conversationDetails.chats.map((chat: any, index: number, array: any[]) => {
            if (chat.id === action.payload.id) {
              const isLastChat = index === array.length - 1;
              return {
                ...chat,
                responses: isLastChat
                  ? action.payload.responses
                  : action.payload.responses.map((res: any) => ({
                      ...res,
                      followUpQuestions: [], // Ensure correct key name
                    })),
              };
            }
            return chat;
          }),
        },
      };
    case REGENERATE_CHAT_FAILURE:
      return { ...state, regenerateLoading: false, error: action.payload };
    case HIDE_CONVERSATION_PANE:
      return { ...state, showConversationPane: false };
    case SHOW_CONVERSATION_PANE:
      return { ...state, showConversationPane: true };
    case IS_CONVERSATION_UPDATED:
      return { ...state, isConversationUpdated: action.payload };
    case SET_DEFAULT_CONVERSATION:
        return { ...state, conversationDetails: defaultConversationDetails };  
    default:
      return state;
  }
};

export default ChatConversationReducer;
